import { createRef, useEffect, useState } from 'react';
import { ModalBody, ModalHeader, Spinner, Text } from '@chakra-ui/react';
import classnames from 'classnames';
import { CbButton } from 'ui/components/Buttons/CbButton';
import ArrowLeft from '../../Icons/ArrowLeft';
import Refresh from '../../Icons/Refresh';
import { CbInput } from '../../Inputs/CbInput';
import { useGIPHY } from 'hooks';
import styles from './CbGiphy.module.css';
export const CbGiphy = ({
  onReturnToCreatePost,
  onSelectImage
}) => {
  const [input, setInput] = useState('');
  const {
    canShuffle,
    hasNoResults,
    isLoading,
    results,
    search,
    shuffle
  } = useGIPHY();
  const ref = createRef<HTMLInputElement>();
  useEffect(() => {
    if (!input) return;
    search(input);
  }, [input]);
  useEffect(() => {
    ref.current?.focus();
  }, []);
  const renderGIPHYResult = imageURL => <img className={styles.result} key={imageURL} onClick={() => onSelectImage(imageURL)} src={imageURL} data-sentry-component="renderGIPHYResult" data-sentry-source-file="CbGiphy.tsx" />;
  const renderResults = results => {
    if (!input) return null;
    if (hasNoResults) return <p className={styles.hasNoResults}>
          No results found for <span>{input}</span>
        </p>;
    return results.map(renderGIPHYResult);
  };
  return <>
      <ModalHeader className={styles.header} data-sentry-element="ModalHeader" data-sentry-source-file="CbGiphy.tsx">
        <ArrowLeft className={styles.arrowLeft} onClick={onReturnToCreatePost} data-sentry-element="ArrowLeft" data-sentry-source-file="CbGiphy.tsx" />
        <Text className={styles.title} data-sentry-element="Text" data-sentry-source-file="CbGiphy.tsx">Choose a GIF</Text>
        <div className={styles.poweredByGiphy}>
          <span>Powered by</span>
          <img src="https://arcade-assets-public.s3.amazonaws.com/fun/GIPHY+Transparent+27px.png" />
        </div>
      </ModalHeader>
      <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="CbGiphy.tsx">
        <div className={styles.controls}>
          <CbInput onChange={event => setInput(event.target.value)} placeholder="Search" ref={ref} value={input} data-sentry-element="CbInput" data-sentry-source-file="CbGiphy.tsx" />
          {canShuffle && <CbButton aria-label="Shuffle Results" className={styles.shuffle} onClick={() => shuffle(input)} variant="ghost">
              <div>
                Shuffle
                <Refresh />
              </div>
            </CbButton>}
        </div>
        <div className={classnames(styles.results, isLoading || hasNoResults ? styles.isLoading : styles.loaded)}>
          {isLoading ? <Spinner color="chonky.500" emptyColor="gray.200" margin="auto auto" size="xl" speed="0.65s" thickness="4px" /> : <>{renderResults(results)}</>}
        </div>
      </ModalBody>
    </>;
};